// extracted by mini-css-extract-plugin
export default {"root":"CompanyBadge_root__K4ZQd","rootAccountant":"CompanyBadge_rootAccountant__TtYY1"};